﻿import React, { useEffect } from 'react';
import { Asset } from '../models/asset';
import { PWDates } from '../utilities/pw-dates';

export interface Props {
    instrument: Asset;
}

export default function InstrumentInformation(props: Props) {

    useEffect(() => {
        console.log("props.instrument:", props.instrument);
    }, [props.instrument]);

    //const [showMore, setShowMore] =
    //  useState<boolean>(true);

    let revalidationDateCss = "date-good";

    if (props.instrument &&
        props.instrument.revalidationDate) {
        revalidationDateCss = getValidationDateColor(props.instrument.revalidationDate);
    }

    return (
        <div className="instrument-information-container pw-margin-bottom-05">
            <div className="pw-form-unit pw-comp-10 instrument-information-column">
                <div className="pw-form-unit-label">Asset Number</div>
                <div className="pw-readonly-label">{props.instrument?.formattedAssetNumber
                    ?? props.instrument?.assetNumber ?? 'NA'}</div>
            </div>
            <div className="pw-form-unit pw-comp-10 instrument-information-column">
                <div className="pw-form-unit-label">Asset Name</div>
                <div className="pw-readonly-label">{props.instrument?.assetName ?
                    props.instrument.assetName : 'NA'}</div>
            </div>
            <div className="pw-form-unit pw-comp-10 instrument-information-column">
                <div className="pw-form-unit-label">Revalidation Date</div>
                <div className={`pw-readonly-label ${revalidationDateCss}`}>
                    {props.instrument &&
                        props.instrument.revalidationDate ?
                        PWDates.getDateString(props.instrument.revalidationDate) : 'NA'}
                </div>
            </div>

            {/*
            {showMore &&
                <div className="show-more-link" onClick={onShowMoreClick} >Show more...</div>
            }
            {!showMore &&
                <>
                */}

            {/*<div className="pw-form-unit">*/}
            {/*    <div className="pw-form-unit-label">Description</div>*/}
            {/*    <div className="pw-readonly-label">{props.instrument &&*/}
            {/*        props.instrument.description ?*/}
            {/*        props.instrument.description : 'NA'}</div>*/}
            {/*</div>*/}
            {/*<div className="pw-form-unit">*/}
            {/*    <div className="pw-form-unit-label">Model Number</div>*/}
            {/*    <div className="pw-readonly-label">{props.instrument &&*/}
            {/*        props.instrument.modelNumber ?*/}
            {/*        props.instrument.modelNumber : 'NA'}</div>*/}
            {/*</div>*/}
            {/*<div className="pw-form-unit">*/}
            {/*    <div className="pw-form-unit-label">Serial Number</div>*/}
            {/*    <div className="pw-readonly-label">{props.instrument &&*/}
            {/*        props.instrument.vendorSerialNumber ?*/}
            {/*        props.instrument.vendorSerialNumber : 'NA'}</div>*/}
            {/*</div>*/}
            {/*<div className="pw-form-unit">*/}
            {/*    <div className="pw-form-unit-label">Location</div>*/}
            {/*    <div className="pw-readonly-label">{props.instrument &&*/}
            {/*        props.instrument.location ?*/}
            {/*        props.instrument.location : 'NA'}</div>*/}
            {/*</div>*/}
            {/*
                    <div className="show-more-link" onClick={onShowMoreClick} >Show less...</div>
               */}
        </div>

    );

    /*
    function onShowMoreClick() {
        setShowMore(!showMore);
    }
    */

    function getValidationDateColor(d: Date) {
        let now = new Date();
        let date = new Date(d);

        if (date.getTime() < now.getTime()) {
            return "date-expired";
        }

        const inOneMonth = new Date(now.setMonth(now.getMonth() + 1));

        if (date.getTime() < inOneMonth.getTime())
            return "date-warning";
        else
            return "date-good";
    }
}

